// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const DocsManifestTable: MarkdocTagRegistration = {
  tag: 'markdoc-docs-manifest-table',
  component: 'DocsManifestTable',
  attributes: {
    manifest: {
      type: Object,
      description: 'The docs manifest',
    },
  },
};

export const DocsManifestTableByCondition: MarkdocTagRegistration = {
  tag: 'markdoc-docs-manifest-gated-table',
  component: 'DocsManifestTableByCondition',
  attributes: {
    manifest: {
      type: Object,
      description: 'The docs manifest',
    },
  },
};
